export function metersToMiles(meters: number): string {
  return (meters * 0.000621371192).toFixed(2);
}
